import { Affix } from "@mantine/core";

import { useUser } from "#modules/users/view/useUser";

import { DevtoolsMenu } from "./DevtoolsMenu";

export const DevtoolsPanel = () => {
  const { user } = useUser();

  if (
    import.meta.env["VITE_ENV"] === "development" ||
    import.meta.env["VITE_ENV"] === "staging" ||
    user?.role === "SUPER_ADMIN"
  ) {
    return (
      <Affix position={{ bottom: 60, left: 4 }}>
        <DevtoolsMenu />
      </Affix>
    );
  }

  return null;
};
